import { render, staticRenderFns } from "./StatusesFilter.vue?vue&type=template&id=72cbdaeb&scoped=true"
import script from "./StatusesFilter.vue?vue&type=script&lang=js"
export * from "./StatusesFilter.vue?vue&type=script&lang=js"
import style0 from "./StatusesFilter.vue?vue&type=style&index=0&id=72cbdaeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cbdaeb",
  null
  
)

export default component.exports